import IconRoundWarning from '@flatsy/core/Icon/Warning'
import { SubBody2 } from '@flatsy/core/MaterialUi/Typo'
import theme from '@flatsy/core/MuiTheme/theme'
import i18n from '@flatsy/utils/translations'
import React from 'react'
import { useStyles } from './Style'

const Action: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <IconRoundWarning color={theme.palette.warning.main} />
      <SubBody2 fontColor={theme.palette.warning.main} className={classes.label}>
        {i18n.t('action_needed')}
      </SubBody2>
    </div>
  )
}

export default Action
